<div class="report-info">
  <div class="map" [ngClass]="{'spinner' : loadingData() && !report}">
    <frmg-map [reportData]="reportDataFull"
      (elementClick)="openAnalysisModalById($event)"/>
    </div>
    <div class="filter-container">
      <div class="filter-header">
        <div class="filter-title">Filter</div>
        <button mat-button class="frmg-primary-button header-action" (click)="addAggregation()">
          <inline-svg src="Plus.svg" class="plus-icon"></inline-svg>
          Aggregate Data
        </button>
      </div>
      <div class="filter-config">
        <inline-svg src="Filter.svg" (click)="toggleFilterMenu()" class="filter-icon"></inline-svg>
        @if (filterMenu) {
          <div class="filter-menu" [formGroup]="filterFormGroup">
            <div class="filter-menu-header">
              <span>Filter By</span>
              <inline-svg src="small_close.svg" (click)="toggleFilterMenu()" class="close-icon"></inline-svg>
            </div>
            <div class="filter-menu-body">
              <div class="horizontal-separator"></div>
              <mat-form-field appearance="outline">
                <mat-select formControlName="key" placeholder="Field key" panelClass="filter-select"
                  [compareWith]="compareKeys">
                  @for (key of typedMetaKeys; track chipsTrackBy($index, key)) {
                    <mat-option
                      [value]="key">{{ columnHeader(key.name) }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (filterFormGroup.getRawValue().type !== '__in') {
                <mat-form-field appearance="outline">
                  <mat-select formControlName="type" panelClass="filter-select">
                    @for (type of filterOperators; track type) {
                      <mat-option
                        [value]="type">{{ filterOperatorLabels[type] }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              <div class="value-block">
                @if (filterFormGroup.getRawValue().type === '__in') {
                  <mat-form-field appearance="outline"  class="chip-list">
                    <mat-chip-grid #chipGrid formControlName="value" >
                      @for (value of values; track value) {
                        <mat-chip-row (removed)="removeValue(value)">
                          {{value}}
                          <button matChipRemove [attr.aria-label]="'remove ' + value">
                            <mat-icon>close</mat-icon>
                          </button>
                        </mat-chip-row>
                      }
                    </mat-chip-grid>
                    <input placeholder="Add items..." #valueInput [formControl]="valueCtrl" [matAutocomplete]="auto"
                      [matChipInputFor]="chipGrid"
                      [matChipInputSeparatorKeyCodes]="[]"
                      />
                      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedValue($event)">
                        @for (value of filteredValues | async; track value) {
                          <mat-option [value]="value">
                            {{value}}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  }
                  @if (filterFormGroup.getRawValue().type !== '__in') {
                    <mat-form-field appearance="outline">
                      <input matInput formControlName="value"
                        type='number'
                        required>
                      </mat-form-field>
                    }
              @if (filterFormGroup.getRawValue().type === '__in' && !metadataValues.length) {
                <span class="no_data">-- NO DATA -- </span>
              }
              @if (filterFormGroup.getRawValue().type === '__range') {
                <span class="range-separator"> - </span>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="value2"
                    type='number'
                    required>
                  </mat-form-field>
                }
              </div>
            </div>
            <div class="filter-menu-footer">
              <button mat-button class="frmg-primary-button"
                (click)="toggleFilterMenu(true)" [disabled]="!filterFormGroup.valid">Apply
              </button>
            </div>
          </div>
        }
        <div class="vertical-separator"></div>
        <div class="chip-scroller-container">
          @if (showLeftArrow) {
            <div class="scroll-arrow left" (click)="scrollChips('left')">
              <inline-svg src="arrow-middle.svg" class="arrow-icon" ></inline-svg>
            </div>
          }
          <div class="filter-chips" #chipScroller (scroll)="onScroll()">
            @for (chip of chips; track chip) {
              <div class="chip" (click)="toggleFilterMenu(false, $index)">
                @if ($index !== 0) {
                  <inline-svg src="small_close.svg" (click)="deleteFilter($index)" class="close-icon"></inline-svg>
                }
                <span class="chip-title">{{ columnHeader(chip.key.name) }}</span>
                <div class="vertical-separator"></div>
                @if (chip.type === FilterOperatorsEnum.RANGE) {
                  <span class="chip-value">{{ chip.value + ' - ' + chip.value2 }}</span>
                } @else {
                  @if (chip.value | filterChip:chip.type; as transformed) {
                    <span
                      class="chip-value"
                      [matTooltip]="transformed.tooltip"
                      matTooltipPosition="above"
                      >
                      {{ filterOperatorSymbols[chip.type] }} {{ transformed.display }}
                    </span>
                  }
                }
                <inline-svg src="Input_arrow.svg" class="arrow-icon"></inline-svg>
              </div>
            }
          </div>
          @if (showRightArrow) {
            <div class="scroll-arrow right" (click)="scrollChips('right')">
              <inline-svg src="arrow-middle.svg" class="arrow-icon" ></inline-svg>
            </div>
          }
        </div>
      </div>
      <div class="horizontal-separator"></div>

      <div class="carousel-wrapper">
        <div class="carousel-track" [style.transform]="getTransform()">
          @for (page of paginatedBlocks; track trackPage($index, page)) {
            <div class="carousel-page">
              @switch (currentPage) {
                @case (0) {
                  <div id="chart">
                    <div class="chart-container">
                      @if (chartReady) {
                        <apx-chart
                          [series]="chartOptions.series"
                          [chart]="chartOptions.chart"
                          [labels]="chartOptions.labels"
                          [plotOptions]="chartOptions.plotOptions"
                          [legend]="chartOptions.legend"
                          [colors]="chartOptions.colors"
                          [fill]="chartOptions.fill"
                          [tooltip]="chartOptions.tooltip"
                          [stroke]="chartOptions.stroke"
                          [dataLabels]="chartOptions.dataLabels"
                          [yaxis]="chartOptions.yaxis"
                          [xaxis]="chartOptions.xaxis"
                          [noData]="chartOptions.noData"
                          [grid]="chartOptions.grid"
                        ></apx-chart>
                      }
                    </div>
                  </div>
                }
                @default {
                  @for (item of page; track item) {
                    @if (item !== null && item !== undefined) {
                      @switch (item) {
                        @case ('add') {
                          <div class="add-block" (click)="addAggregation()">
                            <inline-svg src="Plus.svg" class="plus-icon"></inline-svg>
                            <div>Aggregate Data</div>
                          </div>
                        }
                        @default {
                          <div class="block">
                            <div class="block-info">
                              <div class="block-value">
                                @if (item?.unit_before) {
                                  <span>{{ item.unit }}</span>
                                }
                                {{ item.calc?.error || (item.calc?.value.toFixed(item.decimal_places) | number) }}
                                @if (!item?.unit_before) {
                                  <span>{{ item.unit }}</span>
                                }
                              </div>
                              <div class="block-title">{{ item.name }}</div>
                            </div>
                            <div class="block-action">
                              <inline-svg src="remove.svg" class="remove-icon" (click)="deleteAggregation(item.id, page)"></inline-svg>
                            </div>
                          </div>
                        }
                      }
                    }
                  }
                }
              }
            </div>
          }
        </div>
      </div>
      <div class="block-navigation">
        @if (currentPage === 0) {
          <div class="navigation-legend">
            @for (color of chartColors; track color) {
              <div class="legend-block" (click)="selectChart($index)">
                <div class="legend-radio" [ngClass]="chartType === $index ? 'active' : ''"></div>
                @switch ($index) {
                  @case (0) {
                    <div class="legend-label">Point</div>
                  }
                  @case (1) {
                    <div class="legend-label">Line</div>
                  }
                  @case (2) {
                    <div class="legend-label">Polygon</div>
                  }
                }
              </div>
            }
          </div>
        }
        @if (currentPage !== 0) {
          <div class="navigation-spacer"></div>
        }
        <div class="block-counter">
          <div class="scroll-arrow left" (click)="scroll('left')" [class.disabled]="currentPage === 0">
            <inline-svg src="arrow-middle.svg" class="arrow-icon" ></inline-svg>
          </div>
          <inline-svg src="Chart.svg" class="chart-icon" [ngClass]="currentPage==0?'active': ''" (click)="goToChart()"></inline-svg>
          <div class="vertical-separator"></div>
          <span>{{ currentPage + 1 }}/{{ totalPages }}</span>
          <div class="scroll-arrow right" (click)="scroll('right')"
            [class.disabled]="currentPage >= totalPages - 1">
            <inline-svg src="arrow-middle.svg" class="arrow-icon" ></inline-svg>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="download-table" [ngClass]="{'spinner' : loadingData()}">
    <div class="table-header">
      <span>Areas</span>
      <div class="header-control">
        <mat-form-field appearance="outline">
          <inline-svg src="search.svg" class="search-icon" matPrefix></inline-svg>
          <input matInput [formControl]="areaSearchCtrl" placeholder="Search by areas">
        </mat-form-field>
        <inline-svg src="columns.svg" class="columns-icon"
          (click)="toggleColumnMenu()"
        [ngClass]="{'menu-open': columnMenu}">></inline-svg>
        @if (columnMenu) {
          <div class="column-menu-panel">
            <div class="column-header">
              <div>
                <span class="column-header-title">Configure columns</span>
                <inline-svg src="small_close.svg" (click)="toggleColumnMenu()" class="close-icon"></inline-svg>
              </div>
              <div class="horizontal-separator"></div>
            </div>
            <div class="columns-body" (click)="$event.stopPropagation()" cdkDropListGroup>
              <div class="columns-shown"
                cdkDropList
                [cdkDropListData]="displayedColumnsDrag"
                (cdkDropListDropped)="drop($event)">
                @if (displayedColumnsDrag.length) {
                  <span class="list-title">
                    Shown attributes
                  </span>
                }
                @for (column of displayedColumnsDrag; track column; let i = $index) {
                  <div class="list-column" cdkDrag
                    cdkDragPreviewClass="list-column">
                    <inline-svg src="drag.svg"  class="drag-icon"></inline-svg>
                    <span class="cdkDrag">{{ columnHeader(column) }} </span>
                    @if (isColumnRemovable(column)) {
                      <mat-slide-toggle
                        [checked]="true"
                        (change)="toggleColumn(i, column, true)">
                      </mat-slide-toggle>
                    }
                  </div>
                }
              </div>
              <div class="columns-hidden">
                @if (hiddenColumns.length) {
                  <span class="list-title">
                    Hidden attributes
                  </span>
                }
                @for (column of hiddenColumns; track column; let i = $index) {
                  <div class="list-column">
                    <!--                            <inline-svg src="drag.svg"  class="drag-icon"></inline-svg>-->
                    <span class="cdkDrag">{{ columnHeader(column) }} </span>
                    <mat-slide-toggle
                      [checked]="false"
                      (change)="toggleColumn(i, column, false)">
                    </mat-slide-toggle>
                  </div>
                }
              </div>
            </div>
            <div class="column-controls">
            </div>
          </div>
        }
      </div>
    </div>
    <div class="table-container">
      <table mat-table [dataSource]="reportData" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)"
        [matSortDisabled]="loadingData()" matSortDisableClear>
        @for (column of displayedColumns; track column) {
          <ng-container [matColumnDef]="column" [sticky]="column === 'name'"
            [stickyEnd]="column === 'action'">
            <mat-header-cell *matHeaderCellDef mat-sort-header
              [disabled]="column === 'action'">{{ columnHeader(column) }}
            </mat-header-cell>
            @switch (column) {
              @case ('avg_geometry_value') {
                <mat-cell *matCellDef="let element">{{ element.avg_geometry_value?.toFixed(0)  | number }}</mat-cell>
              }
              @case ('action') {
                <mat-cell *matCellDef="let element" class="report-actions">
                  <div class="list-element-actions-menu">
                    <inline-svg src="Hamburger_menu.svg" class="menu-icon"
                      color="#A5B5BD"
                      hoverColor="#7F8F98"
                    [matMenuTriggerFor]="actionMenu" (click)="$event.stopPropagation();"></inline-svg>
                    <mat-menu #actionMenu="matMenu">
                      <button mat-menu-item
                        (click)="downloadArea(element.id, (element.name || element.properties?.name)+'_report')"
                        class="menu-slot">Download Report
                      </button>
                    </mat-menu>
                  </div>
                </mat-cell>
              }
              @default {
                <mat-cell
                  *matCellDef="let element">
                    @if (getValueByPath(element.geometry, column); as value) {
                      @if (isNumber(value) && !isYear(value)) {
                        {{ value | number }}
                      }
                      @if (!isNumber(value) || isYear(value)) {
                        {{ value }}
                      }
                    }
                </mat-cell>
              }
            }
          </ng-container>
        }
        <ng-container matColumnDef="name" [sticky]="true">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Area Name</mat-header-cell>
          <mat-cell *matCellDef="let element"
            [matTooltip]="element.name">
            <div class="area-name-cell">
              <span>
                <inline-svg [src]="getAreaIconType(element)" color="#85BBF3"></inline-svg>
                <div>{{ element.collection_metadata.area_name | truncate: 50 }}</div></span>
<!--                <span> {{ element.properties.address?.display_name }}</span>-->
                <span> Missing Data</span>
              </div>

              <inline-svg src="focus.svg" class="focus-icon" (click)="focusOn(element, $event)"></inline-svg>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"
            [style.border-color]="colors[0]"
            (click)="openAnalysisModal(row)"
            (mouseenter)="highlightOnHover(row)"
          ></mat-row>
        </table>
      </div>

    </div>

